/* eslint import/no-webpack-loader-syntax: off */
import React from 'react';
import axios from 'axios';
// import Draggable from 'react-draggable';

import Lightbox from 'react-image-lightbox';

import { FormattedMessage } from 'react-intl';

import { Context } from '../context/AppContext';

import Wrapper from './Wrapper';
import Header from './Header';
import Top from './Top';
import Bottom from './Bottom';
import Actions from './Actions';
import Tag from './Tag';
import TagIcon from './TagIcon';
import Title from './Title';
import Image from './Image';
import ButtonGroup from './ButtonGroup';
import Hamburger from './Hamburger';
// import FinderView from './FinderView';
import Main from './Main';
import { Sidebar, SidebarLabel, SidebarLink, SidebarLinkText } from './Sidebar';
import { Content, Column, Row, RowLinkText } from './Content';
import Contacts from './Contacts';
import About from './About';

import ToolbarButton from './ToolbarButton';
import IconFolderColored from '-!react-svg-loader!../assets/svg/folder-colored.svg';
import IconChevronLeft from '-!react-svg-loader!../assets/svg/chevron-left.svg';
import IconChevronRight from '-!react-svg-loader!../assets/svg/chevron-right.svg';
import IconClose from '-!react-svg-loader!../assets/svg/close.svg';
import IconMinus from '-!react-svg-loader!../assets/svg/minus.svg';
import IconExpand from '-!react-svg-loader!../assets/svg/expand2.svg';
import IconMusic from '-!react-svg-loader!../assets/svg/music.svg';
import IconPhoto from '-!react-svg-loader!../assets/svg/photo.svg';
import IconPicture from '-!react-svg-loader!../assets/svg/picture.svg';
import IconProject from '-!react-svg-loader!../assets/svg/idea.svg';
import IconVideo from '-!react-svg-loader!../assets/svg/video.svg';
import IconAbout from '-!react-svg-loader!../assets/svg/about.svg';
import IconContact from '-!react-svg-loader!../assets/svg/contact.svg';
import IconFile from '-!react-svg-loader!../assets/svg/file.svg';
// import IconFolder from '-!react-svg-loader!../assets/svg/folder.svg';
// import IconGrid from '-!react-svg-loader!../assets/svg/grid.svg';
// import IconList from '-!react-svg-loader!../assets/svg/list.svg';

// import ScrollContainer from 'react-indiana-drag-scroll';
import PerfectScrollbar from 'react-perfect-scrollbar';

const foldersMap = {
  картины: 1,
  pictures: 1,
  фотографии: 2,
  photos: 2,
  проекты: 3,
  projects: 3,
  видео: 4,
  videos: 4,
};

class Finder extends React.Component {
  state = {
    fullScreen: false,
    directoryTree: null,
    pathArray: [],
    imagesPaths: [],
    position: null,
    selectedIndexes: [],
    lightBoxToggler: false,
    filePath: null,
    menuExpand: true,
    section: 'about', // 'files', 'contacts' or 'about'
  };

  _contentRef = null;

  componentDidMount() {
    this.fetchDirectoryTree();
    if (window.innerWidth < 500) {
      this.setState({ menuExpand: false });
    }
  }

  componentDidUpdate() {
    if (this._contentRef && this.state.section !== 'about') {
      const { scrollWidth, offsetWidth } = this._contentRef;
      if (scrollWidth > offsetWidth) {
        this._contentRef.scrollLeft = scrollWidth - offsetWidth;
      }
    }
  }

  sortFolders = (a, b) =>
    foldersMap[a.name.toLowerCase()] - foldersMap[b.name.toLowerCase()];

  toggleFullScreen = () => {
    const { fullScreen } = this.state;
    this.setState({ fullScreen: !fullScreen });
  };

  fetchDirectoryTree = async (lang) => {
    const locale = lang ? lang : this.context.locale;
    const { data } = await axios.get(`/api/files/${locale}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    // const data = await response.json();
    this.setState({
      directoryTree: data,
    });
  };

  handleClick = (child) => {
    const pathArray = child.path.split('/');
    pathArray.shift(); // remove '/files' and '/locale' folders
    pathArray.shift(); // remove '/files' and '/locale' folders
    // console.log(pathArray);
    this.setState({
      pathArray: pathArray,
      section: 'files',
    });
  };

  handleReadFile = (file, directory) => {
    // console.log('I am fired');
    const { path, name, extension } = file;
    const { children } = directory;
    switch (extension) {
      case '.jpg':
      case '.png':
      case '.jpeg':
        const imagesPaths = children
          .filter((image) => image.extension === '.jpg')
          .map((image) => image.path);
        const position = imagesPaths.findIndex(
          (imagePath) => imagePath === path
        );
        return (
          <Column>
            <Row>
              <Image
                src={`/${path}`}
                onClick={() =>
                  this.setState({
                    lightBoxToggler: true,
                    imagesPaths,
                    position,
                    filePath: `/${path}`,
                  })
                }
              />
            </Row>
          </Column>
        );
      default:
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = `/${path}`
        a.setAttribute('target', '_blank')
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
    }
  };

  renderColumn = (tree, oldTree, path) => {
    // console.log('I am rendered')
    if (tree.type === 'directory') {
      return (
        <PerfectScrollbar style={{ height: '100%', minWidth: '208px', borderRight: '1px solid #dbd9d9' }}>
        <Column>
          {[
            ...tree?.children.filter(dir => dir.type === 'directory'),
            ...tree?.children.filter(dir => dir.type === 'file'),
          ].map((directory, index) => {
            if (directory.type === 'directory')
              return (
                <Row
                  key={`${index}__${directory.name}`}
                  active={path.includes(directory.name)}
                  onClick={() => this.handleClick(directory)}
                >
                  <IconFolderColored />
                  <RowLinkText>{directory.name}</RowLinkText>
                </Row>
              );
            else {
              return (
                <Row
                  key={`${index}__${directory.name}`}
                  active={path.includes(directory.name)}
                  onClick={() => this.handleClick(directory)}
                >
                  <IconFile />
                  <RowLinkText>{directory.name}</RowLinkText>
                </Row>
              );
            }
          })}
        </Column>
        </PerfectScrollbar>
      );
    } else {
      return this.handleReadFile(tree, oldTree);
    }
  };

  getColumns = (tree, path) => {
    if (path.length) {
      if (path.length < 2) {
        const nextTree = tree.children.find((child) => child.name === path[0]);
        return this.renderColumn(nextTree, tree, path);
      } else {
        const nextTree = tree.children.find((child) => child.name === path[0]);
        path.shift();
        return (
          <>
            {this.renderColumn(nextTree, tree, path)}
            {this.getColumns(nextTree, path)}
          </>
        );
      }
    } else {
      return '';
    }
  };

  getFolderIcon = (folderName) => {
    const name = folderName.toLowerCase();
    switch (name) {
      case 'music':
      case 'музыка':
        return <IconMusic />;
      case 'photos':
      case 'фотографии':
        return <IconPhoto />;
      case 'pictures':
      case 'картины':
      case 'работы':
        return <IconPicture />;
      case 'projects':
      case 'проекты':
        return <IconProject />;
      case 'videos':
      case 'видео':
        return <IconVideo />;
      default:
        return <IconFolderColored />;
    }
  };

  changeLanguage = (lang) => {
    const { locale, selectLanguage } = this.context;
    if (lang !== locale) {
      this.setState({ pathArray: [] });
      selectLanguage(lang);
      this.fetchDirectoryTree(lang);
    }
  };

  render() {
    const { close, animationState } = this.props;
    const {
      directoryTree,
      fullScreen,
      lightBoxToggler,
      filePath,
      imagesPaths,
      position,
      section,
    } = this.state;
    const pathArray = [...this.state.pathArray];
    const isMobile = window.screen.width < 501;

    // console.log(directoryTree);
    // console.log('I am rendered');
    return (
      // <Draggable handle='Header' disabled={!animationState === 'entered'}>
      <>
        <Wrapper animationState={animationState} fullScreen={fullScreen}>
          <Header>
            <Top>
              <Actions>
                <Tag tagColor='tag-red' onClick={close}>
                  <TagIcon>
                    <IconClose />
                  </TagIcon>
                </Tag>
                <Tag tagColor='tag-orange' onClick={close}>
                  <TagIcon>
                    <IconMinus />
                  </TagIcon>
                </Tag>
                <Tag tagColor='tag-green' onClick={this.toggleFullScreen}>
                  <TagIcon>
                    <IconExpand />
                  </TagIcon>
                </Tag>
              </Actions>
              <Title>
                <FormattedMessage
                  id='app.name'
                  defaultMessage="Fialkovskaia's Finder"
                />
              </Title>
            </Top>
            <Bottom>
              {isMobile && <ButtonGroup>
                <ToolbarButton
                  onClick={() =>
                    this.setState({ menuExpand: !this.state.menuExpand })
                  }
                >
                  <Hamburger isActive={this.state.menuExpand} />
                </ToolbarButton>
              </ButtonGroup>}
              {/* <ButtonGroup>
                <ToolbarButton _icon={<IconChevronLeft />} _disabled={true} />
                <ToolbarButton _icon={<IconChevronRight />} _disabled={true} />
              </ButtonGroup> */}
              <ButtonGroup>
                <ToolbarButton onClick={() => this.changeLanguage('ru')}>
                  RU
                </ToolbarButton>
                <ToolbarButton onClick={() => this.changeLanguage('en')}>
                  EN
                </ToolbarButton>
                {/* <ToolbarButton _icon={<IconChevronRight />} _disabled={true} /> */}
              </ButtonGroup>
              {/* <FinderView>
                <ButtonGroup group={true}>
                  <ToolbarButton _icon={<IconGrid />} active={true} />
                  <ToolbarButton _icon={<IconList />} />
                  <ToolbarButton _icon={<IconFolder />} />
                </ButtonGroup>
              </FinderView> */}
            </Bottom>
          </Header>

          {/* <ScrollContainer hideScrollbars={false}> */}
          <Main>
            <Sidebar expand={!this.state.menuExpand}>
              {/* <PerfectScrollbar style={{ height: 'calc(100% - 55px)' }}> */}
              <SidebarLabel>
                <FormattedMessage
                  id='app.favorites'
                  defaultMessage='Favorites'
                />
              </SidebarLabel>
              {directoryTree &&
                directoryTree.children.length &&
                directoryTree.children
                  .sort(this.sortFolders)
                  .map((child, index) => (
                    <SidebarLink
                      key={index}
                      onClick={() => this.handleClick(child)}
                      active={pathArray.includes(child.name)}
                    >
                      {this.getFolderIcon(child.name)}
                      <SidebarLinkText expand={!this.state.menuExpand}>
                        {child.name}
                      </SidebarLinkText>
                    </SidebarLink>
                  ))}
              {/* <SidebarLink>
                <IconFolderColored />
                <SidebarLinkText>Applications</SidebarLinkText>
              </SidebarLink>
              <SidebarLink active={true}>
                <IconFolderColored />
                <SidebarLinkText>Desktop</SidebarLinkText>
              </SidebarLink> */}
              <SidebarLabel>
                <FormattedMessage id='app.info' defaultMessage='Info' />
              </SidebarLabel>
              <SidebarLink
                onClick={() =>
                  this.setState({ section: 'about', pathArray: [] })
                }
                active={section === 'about'}
              >
                <IconAbout />
                <SidebarLinkText expand={!this.state.menuExpand}>
                  <FormattedMessage id='app.about' defaultMessage='About me' />
                </SidebarLinkText>
              </SidebarLink>
              <SidebarLink
                onClick={() =>
                  this.setState({ section: 'contacts', pathArray: [] })
                }
                active={section === 'contacts'}
              >
                <IconContact />
                <SidebarLinkText expand={!this.state.menuExpand}>
                  <FormattedMessage
                    id='app.contacts'
                    defaultMessage='Contacts'
                  />
                </SidebarLinkText>
              </SidebarLink>
              {/* </PerfectScrollbar> */}
            </Sidebar>
            <PerfectScrollbar
              containerRef={(ref) => (this._contentRef = ref)}
            >
              <Content>
                {section === 'files' &&
                  directoryTree &&
                  this.getColumns(directoryTree, pathArray)}
                {section === 'contacts' && <Contacts />}
                {section === 'about' && <About />}
              </Content>
            </PerfectScrollbar>
          </Main>
          {/* </ScrollContainer> */}
        </Wrapper>
        {lightBoxToggler && (
          <Lightbox
            mainSrc={imagesPaths[position]}
            nextSrc={imagesPaths[(position + 1) % imagesPaths.length]}
            prevSrc={
              imagesPaths[
                (position + imagesPaths.length - 1) % imagesPaths.length
              ]
            }
            onMovePrevRequest={() =>
              this.setState({
                position:
                  (position + imagesPaths.length - 1) % imagesPaths.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                position: (position + 1) % imagesPaths.length,
              })
            }
            onCloseRequest={() => this.setState({ lightBoxToggler: false })}
          />
        )}
      </>
    );
  }
}

Finder.contextType = Context;

export default Finder;
